<template>
  <v-container background fluid pa-3 v-scroll="onScrollFunction" class="contain_width">
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
  <filter-component :json_data ="form_dialog_data" v-on:set="onCloseFormDialog" />

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>

     <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter" >
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-sm-an>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout
        row
        align-center
        text-xs-center
        style="margin-top:5rem;margin-bottom:15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer">
                <h3>{{$t('message.Docfail')}}</h3>
        </v-flex>
      </v-layout>
    <v-flex lg12 md12 sm12 xs12>
      <v-layout row wrap>
            <v-flex lg4 md6 sm12 xs12 pa-1 v-for="(item, index) in table_data" :key="index">
                <v-card class="coco-box-shadow " style="border-left:5px solid #408550;border-radius:5px">
                  <v-layout row wrap class="coco-list-layout" pa-3>
                    <v-flex lg1 md1 sm1 xs2 text-xs-center style="margin:auto">
                      <v-icon :size="50" style="color:#408550;"> fas fa-file-invoice</v-icon>
                    </v-flex>
                    <v-flex lg8 md9 sm8 xs7>
                      <v-layout row wrap>
                        <v-flex xs12 >
                          <v-layout row wrap>
                            <v-flex lg4 md4 sm4 xs12 pa-1 hidden-xs-only>
                              <strong >{{$t('DocumentID')}} : </strong>
                            </v-flex>
                             <v-flex lg7 md7 sm7 xs12 pa-1>
                              <span> {{item.doc_no }}</span>
                            </v-flex>
                             <v-flex lg4 md4 sm4 xs6 pa-1>
                              <strong>{{$t('Dateperiod')}} : </strong>
                            </v-flex>
                             <v-flex lg7 md7 sm7 xs6 pa-1>
                              <span> {{formatdate(item.payroll_date_begin)}}</span>
                            </v-flex>
                            <v-flex lg4 md4 sm4 xs6 pa-1>
                              <strong>{{$t('todate')}} : </strong>
                            </v-flex>
                             <v-flex lg7 md7 sm7 xs6 pa-1>
                              <span> {{formatdate(item.payroll_date_end)}}</span>
                            </v-flex>
                            <v-flex lg4 md4 sm4 xs6 pa-1>
                              <strong>{{$t('perioddate')}} : </strong>
                            </v-flex>
                             <v-flex lg7 md7 sm7 xs6 pa-1>
                              <span> {{formatdate(item.period_date)}}</span>
                            </v-flex>
                             <v-flex lg4 md4 sm4 xs6 pa-1>
                              <strong>{{$t('Document creator')}} : </strong>
                            </v-flex>
                            <v-flex lg7 md7 sm7 xs6 pa-1>
                              <span> {{item.creator_code}}</span>
                            </v-flex>
                            <v-flex lg12 md12 sm12 xs12 pa-1>
                              <v-icon>info</v-icon>
                              <span  v-if="item.remark != ''">&nbsp;{{item.remark}}</span>
                              <span  v-if="item.remark == ''">&nbsp; - </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex lg1 md1 sm1 xs2>
                      <v-layout row wrap >
                         <v-flex lg1 md2 sm2 xs2 text-xs-right >
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-menu offset-y>
                              <template  slot="activator" >
                                <v-btn icon style="color:rgba(0,0,0,0.54)">
                                  <v-icon >fas fa-ellipsis-v</v-icon>
                                </v-btn> 
                              </template>
                              <v-card class="pa-0" max-width="344">
                                  <v-card-title class="setbox" v-if="permission_view == true || admin == 'true'"> 
                                    <v-btn color="orange" slot="activator" flat @click="goto('payrolldoc/detail/'+item.doc_no+'/'+item.detailsCount )">
                                      <v-icon>search</v-icon>
                                      <span>  {{$t('view')}}</span>
                                    </v-btn>
                                  </v-card-title>
                                  <v-card-title  class="setbox" v-if="permission_edit == true || admin == 'true'">
                                      <v-btn color="red" flat @click="deleteItem(item.doc_no)">
                                        <v-icon>delete</v-icon>
                                        <span>  {{$t('delete')}}</span>
                                      </v-btn>
                                  </v-card-title>
                              </v-card>
                          </v-menu>
                       </v-card-actions>
                      </v-flex>
                     </v-layout>
                      <!-- <v-layout row wrap>
                        <v-flex md12 sm12 xs12 text-xs-center>
                          <v-layout row wrap>
                            <v-flex offset-lg5 offset-md3 offset-xs8 lg3 md4 xs2 v-if="check_permission == true || admin == 'true'">
                              <v-btn
                                color="orange"
                                icon
                                flat
                                @click="goto('payrolldoc/detail/'+item.doc_no )"
                              >
                                <v-icon>search</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex lg3 md4 xs2 v-if="check_permission == true || admin == 'true'">
                              <v-btn color="red" icon flat @click="deleteItem(item.doc_no)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout> -->
                    </v-flex>
                    <!-- <v-flex xs12 class="coco-list-divider" style="margin-top : 10px; margin-bottom : 10px;">
                    <v-divider />
                  </v-flex> -->
                  </v-layout>
                </v-card>
              </v-flex>
      </v-layout>
    </v-flex>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDelete"
        />
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import PayrollService from "@/services/PayrollService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Utils from "@/utils/";
import moment from "moment";
import FilterComponent from "./Filter";
import UserService from "@/services/UserService";
import $ from "jquery";
export default {
  created: async function() {
    this.admin = localStorage._is_admin;
    await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
    await this.checkpermission("PayRollDocumentList");
    console.log(this.check_permission)
    console.log(this.admin)
    this.commitSetToolbar({ patternTool: "0" });
      let v = this;
    this.getPayrollDoc("Form");
  },
  destroyed: function() {
    this.commitToggleAlertDialog({ status: false, message: Object });
  },
  components: {
    DeleteDialog,
    FilterComponent
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate"
    ]),
    ...mapState("app", ["showLoading"]),
    //...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapMutations("filter", [
      "setShowFilter",
      "selectedFormDate",
      "selectedToDate",
      "getAllEmployeeByBranch",
      "selectedPosition"
    ]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
     searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        v.getPayrollDoc("Filter");
      }, 1500);
    },
     onCloseFormDialog(value) {
      this.form_dialog_data.status = false;
      this.onload = true;
      this.getPayrollDoc("Form");
    },
    showFilter(status){
      this.form_dialog_data = {
        status: status,
        data:1
      };
    },
     checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
      } else {
        this.show_search = true;
      }
    },onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      //console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      //console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          console.log('last');
        }
        if(this.processing && this.canLoadMore){
          console.log('not last');
        }
       }*/
    },
    getPayrollDoc() {
      let searchVal = "";
      let department = "";
      let branch = "";
      this.commitSetShowLoading(true);
      if (this.SearchData == undefined) {
        searchVal = "";
      } else {
        searchVal = this.SearchData;
      }
      if (this.department == "All") {
        department = "";
      } else {
        department = this.SearchData;
      }
      if (this.branch == "All") {
        branch = "";
      } else {
        branch = this.SearchData;
      }
      PayrollService.getPayrollDoc(
        this.Search_data, 
        branch, 
        department, 
        this.activePage)
        .then(res => {
          console.log(res.data.content);
          this.table_data = res.data.content;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.form_dialog_data.status = false;
      this.getPayrollDoc();
    },
    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    deleteItem(doc_no) {
      this.delete_dialog_data.status = true;
      let message = "<p>" + this.$t("question.delete") + " " + doc_no + "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.doc_no = doc_no;
    },
    onDelete() {
      PayrollService.deleteListPayRollDocNo(this.delete_dialog_data.doc_no)
        .then(res => {
          console.log(res);
          this.showSnackBar(this.$t("message.delete"), "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getPayrollDoc();
          this.delete_dialog_data.status = false;
        })
        .catch(err => {
          console.log(res);
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    }
  },
  data: () => ({
    Search_data: "",
    show_search: false,
      timeout: null,
      pageActive: 1,
    onload: false,
    processing: false,
    canLoadMore: true,
    admin:false,
    // form_dialog_data: {
    //   status: false,
    //   save_type: String,
    //   data: Object
    // },
       form_dialog_data: {
      status: false,
       },
    delete_dialog_data: {
      status: false
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    activePage: 1,
    delDialogStatus: false,
    delDialog: { roworder: "", device_name: "", emp_code: "" },
    table_data: [],
    permission_edit:false,
    permission_view:false,
     empCode: localStorage._empcode,
    permission:[]

  })
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

span , strong{
  font-family: "Prompt", sans-serif;
}
.back-ground-none {
  background: #ffffff;
  background-size: cover;
}
.setbox{
padding: 0px !important;
text-align: left;
width: 100px;
}
</style>